import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Button,
  Flex,
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  SimpleGrid,
  Spinner,
  useDisclosure,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import axios from "axios";
import LeadCard from "../../../Components/LeadCard";
import Navbar from "../../../Components/Navbar";
import { ChevronRightIcon } from "@chakra-ui/icons";
import CreateLead from "./CreateLead";
import { useSelector } from "react-redux";
import CompanySidebar from "../../../Components/CompanySidebar";

const CompLeadList = () => {
  const [leads, setLeads] = useState([]);
  //console.log("leads", leads);
  const [loading, setLoading] = useState(true);
  const companyIdGlobal = useSelector((store) => store.authentication.users.id);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const fetchLeads = async () => {
    try {
      const res = await axios.get(
        `https://develop-project-360.onrender.com/getAllLeadDealsByRole?type=Lead&adminId=${companyIdGlobal}`
      );
      setLeads(res.data.data);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchLeads();
  }, []);

  if (loading) return <Spinner size="xl" />;

  return (
    <Flex>
      <CompanySidebar />
      <Box
        pl={{ base: "none", md: "10" }}
        pt={{ base: "none", md: "10" }}
        w={{ base: "100%", md: "80%" }}
      >
        <Navbar />

        {/* Main Content */}
        <Box flex="1" p={[4, 6]} overflowY="auto">
          <Heading size={"md"} textAlign={"start"}>
            Leads
          </Heading>
          <Flex
            direction={{ base: "column", md: "row" }}
            justifyContent="space-between"
            alignItems={{ base: "flex-start", md: "center" }}
            flexWrap="wrap"
            gap={4}
          >
            <Breadcrumb
              spacing="8px"
              mt={6}
              mb={6}
              separator={<ChevronRightIcon color="gray.500" />}
            >
              <BreadcrumbItem>
                <BreadcrumbLink href="/company">Dashboard</BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbItem>
                <BreadcrumbLink href="#">Leads</BreadcrumbLink>
              </BreadcrumbItem>
            </Breadcrumb>

            <Flex
              justifyContent={{ base: "flex-start", md: "flex-end" }}
              w={{ base: "100%", md: "auto" }}
            >
              <Button
                onClick={onOpen} // Open the modal on click
                bgGradient="linear(to-r, green.300, teal.100)"
                _hover={{ bgGradient: "linear(to-r, green.100, green.400)" }}
                w={{ base: "100%", sm: "auto" }}
                px={6}
              >
                Create Lead
              </Button>
            </Flex>
          </Flex>

          {/* Modal */}
          <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
              <ModalHeader>Create New Lead</ModalHeader>
              <ModalCloseButton />
              <ModalBody>
                <CreateLead onClose={onClose} addNewLead={fetchLeads} />
              </ModalBody>
            </ModalContent>
          </Modal>

          <SimpleGrid columns={[1, 2, 3]} spacing={6}>
            {leads.map((lead) => (
              <LeadCard key={lead._id} lead={lead} />
            ))}
          </SimpleGrid>
        </Box>
      </Box>
    </Flex>
  );
};

export default CompLeadList;
